// SDK Firebase 12 en mode « compat » : même API que l'ancien SDK v7 (namespacé), pour migrer sans toucher aux
// composants. Passage progressif à l'API modulaire (getFirestore, getDocs…) prévu avec la couche src/services.
import app from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

import { EMULATOR_HOSTS, FIREBASE_ENV, firebaseConfig } from './config';

class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig());

    this.auth = app.auth();
    this.firestore = app.firestore();
    this.storage = app.storage();

    if (FIREBASE_ENV === 'emulator') {
      this.auth.useEmulator(EMULATOR_HOSTS.auth);
      this.firestore.useEmulator(...EMULATOR_HOSTS.firestore);
      this.storage.useEmulator(...EMULATOR_HOSTS.storage);
    }
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  // *** User API ***

  // user = uid => this.db.ref(`users/${uid}`);
  // users = () => this.db.ref('users');

  Projects = () => this.firestore.collection('Projects');
  Groups = () => this.firestore.collection('Groupes');
  Samples = () => this.firestore.collection('Samples');
  Users = () => this.firestore.collection('Users');
  FormLead = () => this.firestore.collection('FormLead');
  ContactForm = () => this.firestore.collection('ContactForm');
  Organisation = () => this.firestore.collection('Organisation');
  Modalities = () => this.firestore.collection('Modalities');
  NewSampleRegistrationForm = () => this.firestore.collection('Users/' + this.auth.currentUser.uid + '/NewSampleRegistrationForms');
  Storage = () => this.storage;
}

export default Firebase;
